import Vue from 'vue';
import {Steps} from '../services/steps.js'

export let bus =    {   currentStep: Steps.NO_KANBAN,
                        vue: new Vue({})
                                };



// WEBPACK FOOTER //
// ./src/core/utils/bus.js